import React, { useState } from "react";
import { Container, Button, Dropdown } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Eye } from "lucide-react";
import { toast, Toaster } from "sonner";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Styles/yellowcalfcss/OtherIncomes.css";

const initialIncomeData = [
  { id: 1, billNumber: "WWXXZZ", supplier: "new supplier", billDate: "2024-03-15", dueDate: "2024-04-15", totalAmount: 120, status: "Pending" },
  { id: 2, billNumber: "DJFHD", supplier: "new supplier", billDate: "2024-03-10", dueDate: "2024-04-10", totalAmount: 66, status: "Pending" },
  { id: 3, billNumber: "DFDFD", supplier: "new supplier", billDate: "2024-3-12", dueDate: "2024-4-12", totalAmount: 0, status: "Pending" },
  { id: 4, billNumber: "DFDFD", supplier: "new supplier", billDate: "2024-3-08", dueDate: "2024-4-08", totalAmount: 450, status: "Pending" },
  { id: 5, billNumber: "WWDJDHF", supplier: "new supplier", billDate: "2024-3-20", dueDate: "2024-4-20", totalAmount: 140, status: "Pending" },
  { id: 6, billNumber: "DFDFDD", supplier: "new supplier", billDate: "2024-3-18", dueDate: "2024-4-18", totalAmount: 1, status: "Pending" },
  { id: 7, billNumber: "DFDFDD", supplier: "new supplier", billDate: "2024-3-14", dueDate: "2024-4-14", totalAmount: 650, status: "Pending" }
];

export default function OtherIncomes() {
  const navigate = useNavigate();

  const [incomeData, setIncomeData] = useState(initialIncomeData);

  const handleIncomeType = () => toast.success("Income Type opened");

  const handleRecordIncome = () => {
   

    const newIncome = {
      id: incomeData.length + 1,
      billNumber: "NEW001",
      supplier: "new supplier",
      billDate: new Date().toISOString().split("T")[0],
      dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
      totalAmount: Math.floor(Math.random() * 500) + 100,
      status: "Pending"
    };
    setIncomeData([...incomeData, newIncome]);
    toast.success("New income record added");
  };

  const handleExport = (type) => {
    if (type === "json") {
      const dataStr = JSON.stringify(incomeData, null, 2);
      const dataBlob = new Blob([dataStr], { type: "application/json" });
      const url = URL.createObjectURL(dataBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "income-data.json";
      link.click();
      toast.success("Data exported as JSON");
    } else if (type === "pdf") {
      const input = document.getElementById("data-capture-wrapper");
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("income-data.pdf");
        toast.success("Data exported as PDF");
      });
    } else if (type === "png") {
      const input = document.getElementById("data-capture-wrapper");
      html2canvas(input).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = "income-data.png";
        link.click();
        toast.success("Data exported as PNG");
      });
    } else if (type === "txt") {
      const dataStr = incomeData.map(item =>
        `${item.id} ${item.billNumber} ${item.supplier} ${item.billDate} ${item.dueDate} ${item.totalAmount} ${item.status}`
      ).join("\n");

      const dataBlob = new Blob([dataStr], { type: "text/plain" });
      const url = URL.createObjectURL(dataBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "income-data.txt";
      link.click();
      toast.success("Data exported as TXT");
    }
  };

  const handleView = (id) => toast.success(`Viewing income record #${id}`);
  const handleEdit = (id) => toast.success(`Editing income record #${id}`);
  const handleDelete = (id) => {
    setIncomeData(incomeData.filter(item => item.id !== id));
    toast.success(`Income record #${id} deleted`);
  };


 
  return (
    <div className="wrap-finances">
      <Toaster position="top-right" />
      <Container fluid className="content-financial-sheet">
        <div className="top-section-utilities">
          <div className="topbar-finances-flex">
            <h3 className="heading-finance-title">Income</h3>
            <div className="control-buttons-zone" style={{marginTop:'5px'}}>
              <Button className="button-finance-option" onClick={() => navigate("/accountant/IncomeType")}>Income Type</Button>
              <Dropdown>
                <Dropdown.Toggle className="button-finance-option dropdown-export-trigger">Export</Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleExport("pdf")}>Save as PDF</Dropdown.Item>
                  <Dropdown.Item onClick={() => handleExport("json")}>Save as JSON</Dropdown.Item>
                  <Dropdown.Item onClick={() => handleExport("png")}>Save as PNG</Dropdown.Item>
                  <Dropdown.Item onClick={() => handleExport("txt")}>Save as TXT</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        <div id="data-capture-wrapper">
          <div className="table-header-wrapper-card" style={{height:'65px'}}>
            <div className="grid-structure-headers"style={{textAlign:'center',marginLeft:'15px', marginTop:'9px', fontWeight:'bold'}}>
              <div className="cell-index-number">Sr No</div>
              <div className="cell-bill-id">Bill Number</div>
              <div className="cell-party-name">Supplier</div>
              <div className="cell-date-entry">Bill Date</div>
              <div className="cell-date-due">Due Date</div>
              <div className="cell-amount-total">Total Amount</div>
              <div className="cell-status-tag">Status</div>
              <div className="cell-action-icons" style={{textAlign:'center',marginLeft:'50px'}}>Actions</div>
            </div>
          </div>

          <div className="records-entries-list">
            {incomeData.map((item, index) => (
              <div key={item.id} className="row-record-block">
                <div className="grid-structure-headers"style={{textAlign:'center', fontSize:'14px'}}>
                  <div className="cell-index-number">{index + 1}</div>
                  <div className="cell-bill-id">{item.billNumber}</div>
                  <div className="cell-party-name">{item.supplier}</div>
                  <div className="cell-date-entry">{item.billDate}</div>
                  <div className="cell-date-due">{item.dueDate}</div>
                  <div className="cell-amount-total">{item.totalAmount}</div>
                  <div className="cell-status-tag">{item.status}</div>
                  <div className="cell-action-icons" style={{gap:'0px', marginLeft:'30px'}}>
                    <button className="btn-inline-icon"onClick={() => navigate(`/accountant/ViewBill/`)} title="View">
                      <Eye size={16} />
                    </button>
                    <button className="btn-inline-icon" onClick={() => navigate(`/accountant/EditBill/`)} title="Edit">
                      <Edit size={16} />
                    </button>
                    <button className="btn-inline-icon" onClick={() => handleDelete(item.id)}>
                      <Trash2 size={16} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="section-footer-">
          <p className="text-showing-counts" style={{marginTop:'12px'}}>
            Showing 1-{incomeData.length} of {incomeData.length} items
          </p>
        </div>
      </Container>
    </div>
  );
}
